"use client";

import * as React from "react";
import { DateRangePickerBlock } from "@/src/components/input/date-range-picker";
import { DateRangeValue } from "@/src/utils/date-range";
import { ComponentPage } from "@/components/docs/component-page";

export default function DocsComponentsDateRangePicker() {
  const [range, setRange] = React.useState<DateRangeValue>({
    kind: "ROLLING",
    value: "past_week",
    yearType: "calendar_year",
  });

  const code = `import { DateRangePickerBlock } from "@/registry/new-york/blocks/date-range-picker/date-range-picker";
import { DateRangeValue } from "@/lib/date-range";
import * as React from "react";

export function DateRangePickerDemo() {
  const [range, setRange] = React.useState<DateRangeValue>({
    kind: "ROLLING",
    value: "past_week",
    yearType: "calendar_year",
  });

  return (
    <DateRangePickerBlock
      label="Date Range"
      helpText="Select a date range"
      value={range}
      onChange={setRange}
      placeholder="Select date range"
    />
  );
}`;

  const installCommand = `npx shadcn@latest add @bluecopa-ui/date-range-picker`;

  return (
    <ComponentPage
      title="Date Range Picker"
      description="Advanced date range picker with preset options (Rolling, Current, Previous, Next) and custom date range selection."
      preview={
        <DateRangePickerBlock
          label="Date Range"
          helpText="Select a date range"
          value={range}
          onChange={setRange}
          placeholder="Select date range"
        />
      }
      code={code}
      installCommand={installCommand}
      apiReference={{
        name: "DateRangePickerBlockProps",
        props: [
          {
            name: "label",
            type: "React.ReactNode",
            description: "Label text displayed above the picker.",
          },
          {
            name: "helpText",
            type: "React.ReactNode",
            description: "Help text displayed below the picker.",
          },
          {
            name: "value",
            type: "DateRangeValue",
            description: "Controlled value. DateRangeValue includes kind, value, yearType, and optional startDate/endDate for CUSTOM.",
          },
          {
            name: "defaultValue",
            type: "DateRangeValue",
            description: "Default value for uncontrolled usage.",
          },
          {
            name: "onChange",
            type: "(next: DateRangeValue) => void",
            description: "Callback fired when the range changes.",
          },
          {
            name: "yearTypeDefault",
            type: '"calendar_year" | "fiscal_year"',
            description: "Default year type. Defaults to 'calendar_year'.",
          },
          {
            name: "fiscalYearStartMonth",
            type: "number",
            description: "Start month for fiscal year (1-12). Defaults to 1 (January).",
          },
          {
            name: "weekStartsOn",
            type: "0 | 1 | 2 | 3 | 4 | 5 | 6",
            description: "Day of week that starts the week. Defaults to 1 (Monday).",
          },
          {
            name: "placeholder",
            type: "string",
            description: "Placeholder text. Defaults to 'Select date range'.",
          },
        ],
      }}
    />
  );
}

